import React, { ReactNode } from "react";
import { Checkbox, DateTimeInput, Input, InputContainer, Search } from "finform";
import { ContactTaskRepeatConstants } from "finhelper";

import { Body, Title3 } from "#app/components/texts/Typography";
import SelectType from "#app/components/Relations/Contacts/SelectType";
import { CLIENT_TYPE, CONTACT_TYPE } from "#app/pages/Relations/Tasks/form/TaskForm";

import { Row } from "#app/pages/styles";
import { SelectItem } from "#app/components/Calendar/styles";

type NullableSearchFieldString = string | null | undefined;

interface OnSearchInputInterface {
    id: number | NullableSearchFieldString; // id здесь - составной идентификатор в виде СТРОКИ, состоит из собственно id и типа пользователя (contact либо user)
    name: NullableSearchFieldString;
}

const NewTaskForm: React.FC<any> = ({
    type,
    setType,
    typeId,
    setTypeId,
    comment,
    setComment,
    startDate,
    setStartDate,
    endDate,
    setEndDate,
    contactId,
    setContactId,
    search,
    setSearch,
    repeatId,
    setRepeatId,
    renderButtons,
    children,
    contacts,
    id,
    getError,
}) => {
    return (
        <React.Fragment>
            <div>
                <Row>
                    <Body darkGrey style={{ marginLeft: "15px", width: "100%", textAlign: "left" }}>
                        Тип
                    </Body>
                    <SelectType typeId={typeId} setType={setTypeId} />
                </Row>
                <Row>
                    <InputContainer style={{ height: "50px" }} error={getError("comment")}>
                        <Input
                            id="comment"
                            placeholder={"Добавьте комментарий"}
                            value={comment}
                            onChange={setComment}
                        />
                    </InputContainer>
                </Row>
                <Row>
                    <InputContainer error={getError("start_at")}>
                        <DateTimeInput
                            id="start_at"
                            placeholder={"Дата и время начала"}
                            value={startDate}
                            onChange={setStartDate}
                        />
                    </InputContainer>
                    <InputContainer error={getError("end_at")}>
                        <DateTimeInput
                            id="end_at"
                            placeholder={"Дата и время завершения"}
                            value={endDate}
                            onChange={setEndDate}
                        />
                    </InputContainer>
                </Row>
                <Row>
                    <div style={{ width: "100%", margin: "0 20px", display: "flex" }}>
                        <Checkbox
                            checked={type === CONTACT_TYPE}
                            style={{ margin: "10px 0" }}
                            textStyle={{ color: "#ffff" }}
                            text="Контакт"
                            toggleCallback={() => setType(CONTACT_TYPE)}
                            id="contact-checkbox"
                        />
                        <Checkbox
                            checked={type === CLIENT_TYPE}
                            style={{ margin: "10px 0" }}
                            textStyle={{ color: "#ffff" }}
                            text="Клиент"
                            toggleCallback={() => setType(CLIENT_TYPE)}
                            id="user-checkbox"
                        />
                    </div>
                </Row>
                <Row>
                    <div id="task-form__client-dropdown-container">
                        <InputContainer error={getError("prepared_user_id")}>
                            <Search
                                name="prepared_user_id"
                                placeholder={type === CLIENT_TYPE ? "Клиент" : "Контакт"}
                                options={contacts.filter((user: { innerType: string }) => {
                                    if (type === CLIENT_TYPE && user.innerType === "user") {
                                        return true;
                                    } else if (
                                        type === CONTACT_TYPE &&
                                        user.innerType === "contact"
                                    ) {
                                        return true;
                                    }

                                    return false;
                                })}
                                value={contactId}
                                onChange={(searchInput: any): void => {
                                    // @TODO вернуть OnSearchInputInterface вместо any, когда будет добавлена реализация
                                    if (searchInput) {
                                        setContactId(searchInput.id);
                                        setSearch(searchInput.name);
                                    }
                                }}
                                search={search}
                                onSearch={setSearch}
                            />
                        </InputContainer>
                    </div>
                </Row>
                <Row>
                    <Body darkGrey style={{ marginLeft: "15px", width: "100%", textAlign: "left" }}>
                        Повторение задачи
                    </Body>
                    {repeatId > ContactTaskRepeatConstants.REPEAT_NONE ? (
                        <SelectItem
                            className="active"
                            onClick={() => {
                                setRepeatId(ContactTaskRepeatConstants.REPEAT_NONE);
                            }}
                        >
                            <Body>Завершить повторение</Body>
                        </SelectItem>
                    ) : (
                        ContactTaskRepeatConstants.statuses.map((status: number, key: number) => {
                            return (
                                <SelectItem
                                    key={key}
                                    className={repeatId === status ? "active" : ""}
                                    onClick={() => {
                                        setRepeatId(status);
                                    }}
                                >
                                    <Body>{ContactTaskRepeatConstants.getTextByType(status)}</Body>
                                </SelectItem>
                            );
                        })
                    )}
                </Row>
                <Row></Row>
                {!!id && children?.length > 0 && (
                    <Row style={{ marginLeft: "10px", marginTop: "10px" }}>
                        <Title3 white left full>
                            Связанные подзадачи
                        </Title3>
                        <div style={{ display: "flex", marginTop: "15px", width: "100%" }}></div>
                    </Row>
                )}
            </div>
            {renderButtons()}
        </React.Fragment>
    );
};

export default NewTaskForm;
